import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";

export class VPoolContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, [], provider);
    }

    async getBalanceAsync():Promise<string>{
        const balance = await this._provider.getBalanceAsync(this.address);
        return this._toDecimal(balance);
    }
}